import { render, staticRenderFns } from "./OperationData.vue?vue&type=template&id=18123c70&scoped=true&"
import script from "./OperationData.vue?vue&type=script&lang=js&"
export * from "./OperationData.vue?vue&type=script&lang=js&"
import style0 from "./OperationData.vue?vue&type=style&index=0&id=18123c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18123c70",
  null
  
)

component.options.__file = "OperationData.vue"
export default component.exports